module.exports = __webpack_public_path__ + "img/gold4.a7f28460.png";